import { CalendarDays } from 'lucide-react';
import type { GiornoEvento } from '@eventi/tipi.ts';
import { cn } from '../../lib/cn';
import { tesseraData } from '../../lib/eventi/riepilogo';

/** Il primo giorno dell'evento come foglietto del calendario; senza date, l'icona del calendario. */
export function TesseraData({ giorni, className }: { giorni: GiornoEvento[]; className?: string }) {
  const data = tesseraData(giorni);
  return (
    <div
      aria-hidden
      className={cn('h-14 w-14 flex-shrink-0 overflow-hidden rounded-xl border border-gray-200 bg-white text-center shadow-sm', className)}
    >
      {data ? (
        <>
          <div className="bg-primary-600 py-0.5 text-[10px] font-bold tracking-wider text-white">{data.mese}</div>
          <div className="text-xl font-bold leading-9 tabular-nums text-gray-900">{data.giorno}</div>
        </>
      ) : (
        <div className="flex h-full items-center justify-center text-neutral-300">
          <CalendarDays className="h-6 w-6" />
        </div>
      )}
    </div>
  );
}
